"use client";

import { useReportWebVitals } from "next/web-vitals";
import { useCallback } from "react";
import { useAnalytics } from "./initialise-analytics";

export const useWebVitalsAnalytics = () => {
  const { pushToDataLayer } = useAnalytics();

  // The data layer can time out before load; keep a stable reporter as a fallback.
  useReportWebVitals(
    useCallback(
      (metric) => {
        if (metric.name === "FCP") {
          pushToDataLayer({
            firstContentfulPaintData: { value: Math.round(metric.value) },
          });
        } else if (metric.name === "TTFB") {
          pushToDataLayer({
            timeToFirstByteData: { value: Math.round(metric.value) },
          });
        }
      },
      [pushToDataLayer],
    ),
  );
};
